import { render, staticRenderFns } from "./CopyStakeStreamRecordingsFilter.vue?vue&type=template&id=82b151f0&scoped=true&lang=pug"
import script from "./CopyStakeStreamRecordingsFilter.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStreamRecordingsFilter.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeStreamRecordingsFilter.vue?vue&type=style&index=0&id=82b151f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b151f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
